import React, { useRef, useState, useEffect } from "react";
import { motion, useInView } from "framer-motion";
import Banner from '../../components/Banner';
import Breadcrumb from '../../components/Breadcrumb';
import SEO from '../../components/SEO';
import './Healthcare.css';
import HealthcareMain from '../../images/industries/healthcare-thumb.jpg'
import goalImg from "../../images/industries/pro_final.jpg";
import outcomeImg from "../../images/industries/pro_goal.jpg";
import Testimonials from "../../components/Testimonials";

const Healthcare = () => {

    const ref = useRef(null);
    const isInView = useInView(ref, { amount: 0.4 });

    const [counts, setCounts] = useState({
        projects: 0,
        clients: 0,
        experience: 0
    });

    // Custom counter function
    useEffect(() => {
        if (!isInView) return;

        const duration = 2000;
        const startTime = performance.now();

        const animate = (currentTime) => {
            const progress = Math.min((currentTime - startTime) / duration, 1);

            setCounts({
                projects: Math.floor(progress * 582),
                clients: Math.floor(progress * 215),
                experience: Math.floor(progress * 30)
            });

            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        };

        requestAnimationFrame(animate);

    }, [isInView]);

    const container = {
        hidden: {},
        show: { transition: { staggerChildren: 0.2 } }
    };

    const item = {
        hidden: { opacity: 0, y: 40 },
        show: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6 }
        }
    };

    const fadeUp = {
        hidden: { opacity: 0, y: 60 },
        show: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.7, ease: "easeOut" }
        }
    };

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
        >
            <SEO title="Healthcare Industry Solutions" description="IT Solutions for Healthcare - Fortune Cloud Solutions" />
            <Banner title="HEALTHCARE INDUSTRY SOLUTIONS" image="/images/manufacturing.png" />

            <div className="project-section pt-5">
                <Breadcrumb />
                <div className="thumb-img container ">
                    <img src={HealthcareMain} className="img-fluid mb-5" alt="Healthcare" />
                </div>

                <section className="" ref={ref}>
                    <div className="container">
                        <div className="row g-5">

                            {/* LEFT SIDE */}
                            <motion.div
                                className="col-lg-8"
                                variants={container}
                                initial="hidden"
                                animate={isInView ? "show" : "show"}
                            >

                                <motion.div variants={item} className="section-heading">
                                    <span className="heading-line"></span>
                                    <h2>About client</h2>
                                </motion.div>

                                <motion.p variants={item} className="about-text">
                                    European languages are members of the same family. The languages only differ in their grammar, their pronu nciation and their most common words. pronunciation and more common words. If several languages coalesce.  over the years, sometimes by accident, sometimes on purpose. Over the years, sometimes by accident, sometimes on purpose. European languages are members of the same family. The languages only differ in their grammar, their pronu nciation and their most common words. pronunciation and more common words. If several languages coalesce.
                                </motion.p>

                                {/* STATS */}
                                <motion.div variants={item} className="stats-wrapper">

                                    <div className="stat-card text-center">
                                        <h3>{counts.projects}</h3>
                                        <p>Projects completed for our clients.</p>
                                    </div>

                                    <div className="stat-card text-center">
                                        <h3>{counts.clients}+</h3>
                                        <p>Experienced serving to clients.</p>
                                    </div>

                                    <div className="stat-card text-center">
                                        <h3>{counts.experience}+</h3>
                                        <p>Years experience in consulting.</p>
                                    </div>

                                </motion.div>

                            </motion.div>


                            {/* RIGHT SIDE */}
                            <motion.div
                                className="col-lg-4"
                                variants={item}
                                initial="hidden"
                                animate={isInView ? "show" : "hidden"}
                            >
                                <div className="project-info-card">

                                    <div className="section-heading">
                                        <span className="heading-line"></span>
                                        <h3>Project information</h3>
                                    </div>

                                    <ul className="info-list">
                                        <li><strong>Skills:</strong> Photoshop, Illustrator</li>
                                        <li><strong>Client:</strong> John Dibag</li>
                                        <li><strong>Completed Date:</strong> 20 - 04 - 2021</li>
                                        <li><strong>Manager:</strong> Marvelon Mizuk</li>
                                        <li><strong>Location:</strong> New York, NY, USA</li>
                                    </ul>

                                </div>
                            </motion.div>

                        </div>
                    </div>
                </section>

                <div className="project-extra-wrapper py-5">

                    {/* ================= PROJECT GOALS ================= */}
                    <motion.section
                        className="project-block container"
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: true, margin: "-80px" }}
                    >
                        <div className="row align-items-center g-5">
                            {/* RIGHT IMAGE */}
                            <div className="col-lg-6">
                                <div className="image-wrapper text-center">
                                    <img src={goalImg} alt="Project Goals w-75" />
                                </div>
                            </div>

                            {/* LEFT TEXT */}
                            <div className="col-lg-6">
                                <div className="section-heading">
                                    <span className="heading-line"></span>
                                    <h2>Project goals</h2>
                                </div>

                                <p>
                                    European languages are members of the same family. The languages only
                                    differ in their grammar and pronunciation.
                                </p>

                                <ul className="custom-list">
                                    <li>Digital how will activities impact traditional manufacturing.</li>
                                    <li>All these digital elements and projects aim to enhance.</li>
                                    <li>I monitor my staff with software that takes screenshots.</li>
                                    <li>Lorem magna niacin sodium liquam hendrerit.</li>
                                    <li>Minim veniam quis niacin nostrud exerci dolor.</li>
                                </ul>

                                <p>
                                    Over the years, sometimes by accident, sometimes on purpose.
                                </p>
                            </div>
                        </div>
                    </motion.section>

                    {/* ================= FINAL OUTCOME ================= */}
                    <motion.section
                        className="project-block container"
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: true, margin: "-80px" }}
                    >
                        <div className="row align-items-center g-5 flex-lg-row-reverse">

                            {/* LEFT IMAGE */}
                            <div className="col-lg-6">
                                <div className="image-wrapper video-wrapper text-center">
                                    <img src={outcomeImg} alt="Final Outcome" />

                                    {/* PLAY BUTTON */}
                                    <div className="play-button">
                                        ▶
                                    </div>
                                </div>
                            </div>

                            {/* RIGHT TEXT */}
                            <div className="col-lg-6">
                                <div className="section-heading">
                                    <span className="heading-line"></span>
                                    <h2>Final outcome of this project</h2>
                                </div>

                                <p>
                                    The languages only differ in grammar and pronunciation. European
                                    languages are members of the same family.
                                </p>

                                <ul className="custom-list">
                                    <li>How digital activities impact traditional manufacturing.</li>
                                    <li>All digital elements aim to enhance.</li>
                                    <li>I monitor staff with screenshots software.</li>
                                    <li>Lorem magna niacin sodium liquam hendrerit.</li>
                                    <li>Minim veniam quis niacin nostrud exerci dolor.</li>
                                </ul>

                                <p>
                                    Over the years, sometimes by accident, sometimes on purpose.
                                </p>
                            </div>

                        </div>
                    </motion.section>

                    {/* Testimonial */}
                    {/* <Testimonials /> */}

                </div>
            </div>
        </motion.div>
    );
};

export default Healthcare;
